import axios from 'axios';

import { getConfig } from '../common/config';

export type ClientUserGroup = {
  client_id: number;
  client_name: string;
  user_groups: UserGroup[];
};
export interface UserGroup {
  user_group_id: string;
  user_group_name: string;
}

const PERSONA_PATH = 'api/persona';

const config = getConfig();

export const getUserGroupNamesForUser = async (token: string): Promise<ClientUserGroup> => {
  try {
    let headers: Record<string, string> = { Authorization: `Bearer ${token}` };
    const impersonation = window.localStorage.getItem('impersonation');
    if (impersonation) {
      headers = {
        ...headers,
        'X-Impersonate-Client': impersonation,
      };
    }
    const url = `${config.BASE_URL}${PERSONA_PATH}`;
    const { data } = await axios.get<ClientUserGroup>(`${url}/client-user-groups`, {
      headers,
    });
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};
